/**
 * Custom main product — mirrors nf-download Water Products my-swiper behavior.
 * One JSON payload per section: script#custom-main-product-data-{sectionId}
 */
(function () {
  const DATA_ID_PREFIX = 'custom-main-product-data-';

  if (!window.__customMainProductPopstate) {
    window.__customMainProductPopstate = true;
    window.addEventListener('popstate', function () {
      document.querySelectorAll('[id^="shopify-section-"]').forEach(function (el) {
        if (typeof el.customMainProductApplyUrl === 'function') {
          el.customMainProductApplyUrl();
        }
      });
    });
  }

  function escAttr(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function slideHasImage(x) {
    if (!x || x.image == null) return false;
    return String(x.image).trim() !== '';
  }

  function slidesWithImages(slides) {
    if (!Array.isArray(slides)) return [];
    return slides.filter(slideHasImage);
  }

  function getHandleFromLocation() {
    const path = window.location.pathname;
    const m = path.match(/\/products\/([^/?#]+)/);
    if (m) return decodeURIComponent(m[1]);
    try {
      const sp = new URLSearchParams(window.location.search);
      const q = sp.get('product') || sp.get('product_handle');
      if (q) {
        const s = String(q).replace(/^\/+|\/+$/g, '');
        const parts = s.split('/');
        return parts[parts.length - 1] || null;
      }
    } catch (e) {}
    return null;
  }

  function normalizeShopifyPath(url) {
    if (!url) return '';
    try {
      if (String(url).indexOf('//') !== -1) {
        const u = new URL(url, window.location.origin);
        return u.pathname + u.search;
      }
      return String(url).split('#')[0];
    } catch (e) {
      return String(url).split('#')[0];
    }
  }

  function initSection(sectionId, data) {
    const root = document.getElementById('shopify-section-' + sectionId);
    if (!root) return;

    const categoryBg = data.categoryBg || '';
    const rawBlocks = Array.isArray(data.blocks) ? data.blocks : [];

    const orderedCategories = [];
    const categoryToBlocks = {};
    for (let b = 0; b < rawBlocks.length; b++) {
      const block = rawBlocks[b];
      const cat = String(block.category || '').trim();
      if (!categoryToBlocks[cat]) {
        categoryToBlocks[cat] = [];
        orderedCategories.push(cat);
      }
      categoryToBlocks[cat].push(block);
    }

    let firstCategoryMeta = orderedCategories.map(function (name) {
      return { categoryName: name, count: categoryToBlocks[name].length };
    });

    let firstCurrentIndex = 0;
    let secondCategory = categoryToBlocks[orderedCategories[0]] || [];
    let secondCurrentIndex = 0;
    let flavorData = [];
    let realIndex = 0;
    let mySwiper = null;

    function findIndicesForHandle(handle) {
      if (!handle) return null;
      const h = String(handle).toLowerCase();
      for (let fi = 0; fi < orderedCategories.length; fi++) {
        const blocks = categoryToBlocks[orderedCategories[fi]];
        for (let si = 0; si < blocks.length; si++) {
          const ph = blocks[si].productHandle;
          if (ph && String(ph).toLowerCase() === h) {
            return { firstIdx: fi, secondIdx: si };
          }
        }
      }
      return null;
    }

    function syncUrlToCurrentProduct() {
      const block = secondCategory[secondCurrentIndex];
      if (!block || !block.productUrl) return;
      const next = normalizeShopifyPath(block.productUrl);
      if (!next) return;
      const cur = window.location.pathname + window.location.search;
      if (next === cur) return;
      try {
        history.pushState({ customMainProductSection: sectionId }, '', next);
      } catch (e) {}
    }

    const flavorContainer = root.querySelector('.flavor-data');
    const wrapper = flavorContainer && flavorContainer.querySelector('.swiper-wrapper');
    const firstWrap = root.querySelector('.first-category-wrap');
    const firstUl = root.querySelector('.first-category');
    const firstInkBar = root.querySelector('.first-category-ink-bar');
    const secondUl = root.querySelector('.second-category');
    const prevBtn = root.querySelector('.swiper-button-prev1');
    const nextBtn = root.querySelector('.swiper-button-next1');
    const itemIndexEl = root.querySelector('.item-index');
    const itemTotalEl = root.querySelector('.item-total');

    function currentProductSlides() {
      const p = secondCategory[secondCurrentIndex];
      return p && Array.isArray(p.slides) ? p.slides : [];
    }

    function setFlavorDataFromProduct() {
      flavorData = slidesWithImages(currentProductSlides());
    }

    function setPageInfo() {
      const n = flavorData.length;
      if (itemIndexEl) itemIndexEl.textContent = n === 0 ? '0' : String(realIndex + 1);
      if (itemTotalEl) itemTotalEl.textContent = String(n);
      updateNavDisabled();
    }

    function setPageNum() {
      if (itemIndexEl) itemIndexEl.textContent = String(realIndex + 1);
      updateNavDisabled();
    }

    function updateNavDisabled() {
      const n = flavorData.length;
      if (prevBtn) {
        if (n === 0 || realIndex <= 0 || n <= 1) prevBtn.classList.add('disabled');
        else prevBtn.classList.remove('disabled');
      }
      if (nextBtn) {
        if (n === 0 || realIndex >= n - 1 || n <= 1) nextBtn.classList.add('disabled');
        else nextBtn.classList.remove('disabled');
      }
    }

    function renderFlavorData() {
      if (!wrapper || !flavorContainer) return;

      if (mySwiper && typeof mySwiper.destroy === 'function') {
        mySwiper.destroy(true, true);
        mySwiper = null;
      }

      const n = flavorData.length;
      if (n === 0) {
        wrapper.innerHTML = '';
        realIndex = 0;
        setPageInfo();
        return;
      }

      if (realIndex > n - 1) realIndex = n - 1;

      const curBlock = secondCategory[secondCurrentIndex];
      const badgeTopUrl =
        curBlock && curBlock.badgeTopUrl ? String(curBlock.badgeTopUrl).trim() : '';
      const badgeBottomUrl =
        curBlock && curBlock.badgeBottomUrl ? String(curBlock.badgeBottomUrl).trim() : '';
      const badgeTopSrcset =
        curBlock && curBlock.badgeTopSrcset ? String(curBlock.badgeTopSrcset).trim() : '';
      const badgeBottomSrcset =
        curBlock && curBlock.badgeBottomSrcset ? String(curBlock.badgeBottomSrcset).trim() : '';
      const badgeTopAlt =
        curBlock && curBlock.badgeTopAlt != null ? String(curBlock.badgeTopAlt) : '';
      const badgeBottomAlt =
        curBlock && curBlock.badgeBottomAlt != null ? String(curBlock.badgeBottomAlt) : '';
      const productImageAlt = escAttr(
        curBlock && curBlock.secondaryTitle != null ? String(curBlock.secondaryTitle) : ''
      );
      const BADGE_SIZES = '(max-width: 767.98px) 7.4vw, 3.9vw';

      let certificationBadgesHtml = '';
      if (badgeTopUrl) {
        certificationBadgesHtml +=
          '<div data-v-0078953f="" class="certification-badges certification-badges--top">' +
          '<img data-v-0078953f="" class="cert-badge" src="' +
          escAttr(badgeTopUrl) +
          '"' +
          (badgeTopSrcset ? ' srcset="' + escAttr(badgeTopSrcset) + '" sizes="' + BADGE_SIZES + '"' : '') +
          ' alt="' +
          escAttr(badgeTopAlt) +
          '" width="200" height="200" loading="lazy">' +
          '</div>';
      }
      if (badgeBottomUrl) {
        certificationBadgesHtml +=
          '<div data-v-0078953f="" class="certification-badges certification-badges--bottom">' +
          '<img data-v-0078953f="" class="cert-badge" src="' +
          escAttr(badgeBottomUrl) +
          '"' +
          (badgeBottomSrcset ? ' srcset="' + escAttr(badgeBottomSrcset) + '" sizes="' + BADGE_SIZES + '"' : '') +
          ' alt="' +
          escAttr(badgeBottomAlt) +
          '" width="200" height="200" loading="lazy">' +
          '</div>';
      }

      let htmlStr = '';
      const slideW = '1358px';
      const SLIDE_IMG_SIZES = '(max-width: 767.98px) 208px, 26.146vw';
      flavorData.forEach(function (x, slideIdx) {
        const imgSrc = escAttr(x.image);
        const imgSrcset = x.imageSrcset ? String(x.imageSrcset).trim() : '';
        const imgW = x.imageWidth || 0;
        const imgH = x.imageHeight || 0;
        const isFirstSlide = slideIdx === 0;
        const title = escAttr(x.title != null ? x.title : '');
        const content = x.content != null ? x.content : '';
        const ft = escAttr(x.flavorTitle != null ? x.flavorTitle : '');
        const fc = x.flavorContent != null ? x.flavorContent : '';
        const titleOpen =
          slideIdx === 0
            ? '<h1 data-v-0078953f="" class="title">'
            : '<div data-v-0078953f="" class="title">';
        const titleClose = slideIdx === 0 ? '</h1>' : '</div>';
        htmlStr +=
          '<div data-v-0078953f="" class="swiper-slide" style="width: ' +
          slideW +
          ';"><div data-v-0078953f="" class="img-box fl"><img data-v-0078953f="" src="' +
          imgSrc +
          '"' +
          (imgSrcset ? ' srcset="' + escAttr(imgSrcset) + '" sizes="' + SLIDE_IMG_SIZES + '"' : '') +
          ' width="' +
          imgW +
          '" height="' +
          imgH +
          '" fetchpriority="' +
          (isFirstSlide ? 'high' : 'low') +
          '" loading="' +
          (isFirstSlide ? 'eager' : 'lazy') +
          '" alt="' +
          productImageAlt +
          '">' +
          certificationBadgesHtml +
          '</div><div data-v-0078953f="" class="img-info fl">' +
          titleOpen +
          '' +
          title +
          titleClose +
          '<div data-v-0078953f="" class="title-content"> ' +
          content +
          ' </div><div data-v-0078953f="" class="flavor-title"> ' +
          ft +
          ' </div><div data-v-0078953f="" class="flavor-content"> ' +
          fc +
          ' </div></div></div>';
      });

      wrapper.innerHTML = htmlStr;

      const initialSlideIndex =
        realIndex > flavorData.length - 1 ? flavorData.length - 1 : realIndex;

      const SwiperCtor = window.FoxTheme && window.FoxTheme.Swiper && window.FoxTheme.Swiper.Swiper;
      if (!SwiperCtor) {
        console.warn('Custom main product: FoxTheme.Swiper.Swiper not available');
        return;
      }

      mySwiper = new SwiperCtor(flavorContainer, {
        initialSlide: initialSlideIndex,
        observer: true,
        observeParents: true,
        on: {
          slideChangeTransitionEnd: function () {
            realIndex = this.realIndex;
            setPageNum();
          },
        },
      });

      realIndex = mySwiper.realIndex;
      setPageInfo();
    }

    function applySelectionFromUrl() {
      const handle = getHandleFromLocation();
      if (!handle) return;
      const found = findIndicesForHandle(handle);
      if (!found) return;
      firstCurrentIndex = found.firstIdx;
      secondCurrentIndex = found.secondIdx;
      secondCategory = categoryToBlocks[orderedCategories[firstCurrentIndex]] || [];
      realIndex = 0;
      setFlavorDataFromProduct();
      renderFirstCategory();
      renderSecondCategory();
      renderFlavorData();
      setTimeout(function () {
        if (mySwiper && !mySwiper.destroyed && flavorData.length > 0) {
          mySwiper.slideTo(0, 0, false);
        }
      }, 0);
    }

    const MOBILE_INK_MQ = '(max-width: 767.98px)';

    function isMobileFirstCategoryInk() {
      try {
        return window.matchMedia(MOBILE_INK_MQ).matches;
      } catch (e) {
        return window.innerWidth <= 767.98;
      }
    }

    function syncFirstCategoryInk(options) {
      options = options || {};
      const skipTransition = options.skipTransition === true;
      if (!firstWrap || !firstUl || !firstInkBar) return;
      if (!isMobileFirstCategoryInk()) {
        firstInkBar.style.display = 'none';
        firstInkBar.classList.remove('ant-tabs-ink-bar-animated');
        return;
      }
      const lis = firstUl.querySelectorAll('li');
      if (!lis.length) {
        firstInkBar.style.display = 'none';
        return;
      }
      const idx = Math.min(Math.max(0, firstCurrentIndex), lis.length - 1);
      const li = lis[idx];
      if (!li) return;

      if (skipTransition) {
        firstInkBar.classList.remove('ant-tabs-ink-bar-animated');
      }

      const wrapRect = firstWrap.getBoundingClientRect();
      const liRect = li.getBoundingClientRect();
      const left = liRect.left - wrapRect.left + firstWrap.scrollLeft;
      const w = liRect.width;

      firstInkBar.style.display = 'block';
      firstInkBar.style.width = w + 'px';
      firstInkBar.style.transform = 'translate3d(' + left + 'px, 0px, 0px)';

      if (skipTransition) {
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            firstInkBar.classList.add('ant-tabs-ink-bar-animated');
          });
        });
      } else if (!firstInkBar.classList.contains('ant-tabs-ink-bar-animated')) {
        firstInkBar.classList.add('ant-tabs-ink-bar-animated');
      }
    }

    let firstCategoryInkResizeTimer = null;
    function scheduleSyncFirstCategoryInk() {
      if (firstCategoryInkResizeTimer) clearTimeout(firstCategoryInkResizeTimer);
      firstCategoryInkResizeTimer = setTimeout(function () {
        firstCategoryInkResizeTimer = null;
        syncFirstCategoryInk({ skipTransition: true });
      }, 100);
    }

    function renderSecondCategory() {
      if (!secondUl) return;
      const THUMB_SIZES = '(max-width: 767.98px) 139px, 10.521vw';
      let liStr = '';
      secondCategory.forEach(function (item, index) {
        const thumb = escAttr(item.thumbUrl);
        const thumbSrcset = item.thumbSrcset ? String(item.thumbSrcset).trim() : '';
        const thumbW = item.thumbWidth || 0;
        const thumbH = item.thumbHeight || 0;
        const name = escAttr(item.secondaryTitle);
        liStr +=
          '<li data-v-0078953f="" data-index="' +
          index +
          '" class="' +
          (index === secondCurrentIndex ? 'current' : '') +
          '"><img style="object-fit:contain" data-v-0078953f="" src="' +
          thumb +
          '"' +
          (thumbSrcset ? ' srcset="' + escAttr(thumbSrcset) + '" sizes="' + THUMB_SIZES + '"' : '') +
          ' width="' +
          thumbW +
          '" height="' +
          thumbH +
          '" loading="lazy" alt="' +
          name +
          '" data-index="' +
          index +
          '"><div data-v-0078953f="" data-index="' +
          index +
          '" class="secondaryName"><span data-v-0078953f="" data-index="' +
          index +
          '">' +
          name +
          '<br data-v-0078953f=""></span><span data-v-0078953f="" data-index="' +
          index +
          '" class="arrow"><img data-v-0078953f="" src="' +
          escAttr(categoryBg) +
          '" data-index="' +
          index +
          '"></span></div></li>';
      });
      secondUl.innerHTML = liStr;
    }

    function renderFirstCategory() {
      if (!firstUl) return;
      let liStr = '';
      firstCategoryMeta.forEach(function (item, index) {
        liStr +=
          '<li data-v-0078953f="" data-index="' +
          index +
          '" class="' +
          (index === firstCurrentIndex ? 'current' : '') +
          '"><span data-v-0078953f="" data-index="' +
          index +
          '"> ' +
          escAttr(item.categoryName) +
          ' <em data-v-0078953f="" data-index="0">' +
          item.count +
          '</em></span></li>';
      });
      firstUl.innerHTML = liStr;
      syncFirstCategoryInk({ skipTransition: true });
    }

    function prev() {
      if (flavorData.length > 0 && mySwiper && !mySwiper.destroyed) mySwiper.slidePrev(500);
    }

    function next() {
      if (flavorData.length > 0 && mySwiper && !mySwiper.destroyed) mySwiper.slideNext(500);
    }

    function changeSecondCategory(index) {
      secondCurrentIndex = Number(index);
      realIndex = 0;
      setFlavorDataFromProduct();
      /* Do not call renderSecondCategory() here: it replaces innerHTML and
         recreates every <img>, which flashes. Click handler already sets .current. */
      renderFlavorData();
      setTimeout(function () {
        if (mySwiper && !mySwiper.destroyed && flavorData.length > 0) {
          mySwiper.slideTo(0, 500, false);
        }
      }, 0);
      syncUrlToCurrentProduct();
    }

    function changeFirstCategory(index) {
      const dataIndex = Number(index);
      firstCurrentIndex = dataIndex;
      const catName = orderedCategories[dataIndex];
      secondCategory = categoryToBlocks[catName] || [];
      secondCurrentIndex = 0;
      realIndex = 0;
      setFlavorDataFromProduct();
      renderSecondCategory();
      renderFlavorData();
      setTimeout(function () {
        if (mySwiper && !mySwiper.destroyed && flavorData.length > 0) {
          mySwiper.slideTo(0, 500, false);
        }
      }, 0);
      syncUrlToCurrentProduct();
      syncFirstCategoryInk({ skipTransition: false });
    }

    function bindOp() {
      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          prev();
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          next();
        });
      }
    }

    function bindClickFirstCategory() {
      root.addEventListener('click', function (e) {
        const li = e.target.closest('.first-category li');
        if (!li || !root.contains(li)) return;
        const siblings = li.parentElement ? li.parentElement.querySelectorAll('li') : [];
        siblings.forEach(function (n) {
          n.classList.remove('current');
        });
        li.classList.add('current');
        const idx = li.getAttribute('data-index');
        changeFirstCategory(idx);
      });
    }

    function bindFirstCategoryInkListeners() {
      if (!root.dataset.cmpInkResizeBound) {
        root.dataset.cmpInkResizeBound = '1';
        window.addEventListener('resize', scheduleSyncFirstCategoryInk);
      }
      if (firstWrap && !root.dataset.cmpInkScrollBound) {
        root.dataset.cmpInkScrollBound = '1';
        firstWrap.addEventListener('scroll', function () {
          syncFirstCategoryInk({ skipTransition: true });
        });
      }
    }

    function bindClickSecondCategory() {
      root.addEventListener('click', function (e) {
        const li = e.target.closest('.second-category li');
        if (!li || !root.contains(li)) return;
        const siblings = li.parentElement ? li.parentElement.querySelectorAll('li') : [];
        siblings.forEach(function (n) {
          n.classList.remove('current');
        });
        li.classList.add('current');
        const idx = li.getAttribute('data-index');
        changeSecondCategory(idx);
      });
    }

    if (!orderedCategories.length || !secondCategory.length) {
      renderFirstCategory();
      renderSecondCategory();
      flavorData = [];
      renderFlavorData();
      bindFirstCategoryInkListeners();
      root.customMainProductApplyUrl = function () {};
      return;
    }

    secondCategory = categoryToBlocks[orderedCategories[0]] || [];
    secondCurrentIndex = 0;
    firstCurrentIndex = 0;
    const urlHandle = getHandleFromLocation();
    const urlFound = urlHandle ? findIndicesForHandle(urlHandle) : null;
    if (urlFound) {
      firstCurrentIndex = urlFound.firstIdx;
      secondCurrentIndex = urlFound.secondIdx;
      secondCategory = categoryToBlocks[orderedCategories[firstCurrentIndex]] || [];
    }

    setFlavorDataFromProduct();
    renderFirstCategory();
    renderSecondCategory();
    renderFlavorData();
    bindOp();
    bindClickFirstCategory();
    bindClickSecondCategory();
    bindFirstCategoryInkListeners();

    root.customMainProductApplyUrl = applySelectionFromUrl;
  }

  function runInit() {
    document.querySelectorAll('script[type="application/json"][id^="' + DATA_ID_PREFIX + '"]').forEach(function (el) {
      if (el.dataset.cmpBound === '1') return;
      const sid = el.id.slice(DATA_ID_PREFIX.length);
      if (!sid) return;
      try {
        const data = JSON.parse(el.textContent.trim());
        el.dataset.cmpBound = '1';
        initSection(sid, data);
      } catch (err) {
        console.warn('Custom main product: invalid JSON', sid, err);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runInit);
  } else {
    runInit();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    if (ev.detail && ev.detail.sectionId) {
      const el = document.getElementById(DATA_ID_PREFIX + ev.detail.sectionId);
      if (el) {
        delete el.dataset.cmpBound;
      }
    }
    runInit();
  });
})();
